<template>
  <header>
    <span class="logo-img">
      <img src="../../assets/images/logo-91.svg" />
    </span>
    <span>
       <img src="../../assets/images/ic_map_location.svg"/> {{location}}
    </span>
  </header>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";
import VueCookie from "vue-cookie";
Vue.use(VueCookie);
export default {
  name: "Header",
  data() {
    return {
       location: VueCookie.get('cityName'),
      userProfileImage: null
    };
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
      mounted() {
    let headers = {
      "x-auth-id": this.$cookie.get("X-Auth-Id")
    };
    this.$http
      .get("https://be.payboard.in/PayBoard/rest/user/balance", { headers })
      .then(function(data) {
        this.location = VueCookie.get('cityName')||data.body.data.city.name;
        this.userProfileImage = data.body.data.profileImageUrl;
      });
  }
  
};
</script>

<style></style>
